import { ViewAnonymousPage } from '@live-webinar/view';
import { RouterType } from '@online-webinar/router';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/a/{-$authorizationCode}'].update({
        staticData: { title: { webinar: 'Title.WatchWebinar' } },
        component: ViewAnonymousPage
    });
};
